export const GLOBALS = {
  breakpoints: {
    small: 746,
    tablet: 1024,
    desktop: 1440
  },
  transition: 400,
};

//Lightbox Slider Settings
export const LIGHTBOX_SLIDER = {
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false,
  prevArrow: $('.lightbox-prev-arrow'),
  nextArrow: $('.lightbox-next-arrow'),
};

//Musts Slider Homepage Settings
export const MUSTS_SLIDER_HOMEPAGE = {
  infinite: true,
  speed: 600,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: $('.musts-prev-arrow'),
  nextArrow: $('.musts-next-arrow'),
  responsive: [
    {
      breakpoint: 832,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
};

export const MERCH_SLIDER_HOMEPAGE = {
  infinite: true,
  speed: 600,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: $('.merch-prev-arrow'),
  nextArrow: $('.merch-next-arrow'),
  responsive: [
    {
      breakpoint: 832,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
};

// export const CONTRIBUTIONS_SLIDER = {
//   infinite: true,
//   dots: true,
//   arrows: false,
// };

export const RECIRCULATION_SLIDER = {
  slidesToShow: 4,
  dots: false,
  arrows: false,
  responsive: [
    {
      breakpoint: GLOBALS.breakpoints.small,
      settings: {
        slidesToShow: 1,
        dots: true,
        infinite: true,
      }
    },
  ]
};



// WEBPACK FOOTER //
// ./app/javascript/constants/settings.js